import { ReactNode } from 'react';
import CourseMenu from './components/menu';

interface ICourseTemplate {
  children: ReactNode;
  isLocked?: boolean;
}

export default function CourseTemplate({
  children,
  isLocked = false,
}: ICourseTemplate) {
  return (
    <div className='flex h-full min-h-screen flex-col'>
      <div className='fixed top-0 z-10 w-full'>
        <CourseMenu isLocked={isLocked} />
      </div>

      <div className='bg-color-lighter mt-[78px] h-full w-full flex-1 md:mb-0'>
        {children}
      </div>
    </div>
  );
}
